export enum ContractStateEnum {
  Draft,
  Executed,
  Terminated
}

export enum ContractPhaseEnum {
  Draft = 1,
  Pending,
  Active,
  Expired,
  Terminated
}

export enum ContractRenewalStateEnum {
  NotStarted,
  AwaitingConfirmation,
  ConfirmedWithoutChanges,
  ConfirmedWithChanges,
  Declined
}

export const CONTRACT_DEFAULT_GRACE_PERIOD = 30;

export const CONTRACT_THIRTY_DAY_RENEWAL_DATE_RANGE = 30;

export const CONTRACT_SIXTY_DAY_RENEWAL_DATE_RANGE = 60;
